module.exports = __webpack_public_path__ + "img/Jc.e7cb2763.png";